module.exports = __webpack_public_path__ + "img/ctm-phone-selected.c99cd665.svg";